module.exports = __webpack_public_path__ + "img/27_58.777a38ae.png";